<div class="modal-header border-bottom-0 pb-md-0">
  <div class="d-inline-block">
    <h5 class="modal-title d-block text-primary">{{translationPrefix + '.heading' | translate}}</h5>
    <span class="d-block">{{translationPrefix + '.disclaimer' | translate}}</span>
  </div>
  <button (click)="activeModal.dismiss('Cross click')" aria-label="Close" class="close" type="button">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body pt-0 mt-3 mt-md-4">
  @if (pcpProviders?.items?.length) { @for (item of pcpProviders.items | paginate: {itemsPerPage: pageSize, currentPage: page, totalItems:
  pcpProviders.total}; track item) {
  <div class="row my-3">
    <div class="col-12">
      @if (shouldUseV2) {
      <app-pcp-item-v2 (itemSelected)="emitSelectionMade($event)" [pcpInfo]="$any(item)"></app-pcp-item-v2>
      } @else {
      <app-pcp-item-v3 (itemSelected)="emitSelectionMade($event)" [pcpInfo]="$any(item)"></app-pcp-item-v3>
      }
    </div>
  </div>
  }
  <div class="row mb-3 text-center">
    <div class="col-12">
      <pagination-controls (pageChange)="emitChangePage($event)" class="custom-pagination"></pagination-controls>
    </div>
  </div>
  } @if (pcpProviders === undefined) {
  <div class="row my-3">
    <div class="col-12 text-center">{{'common.loading' | translate}}</div>
  </div>
  } @if (pcpProviders !== undefined && (!pcpProviders?.items?.length || !pcpProviders?.total)) {
  <div class="row my-3">
    <div class="col-12 text-center">{{'common.noDataFound' | translate}}</div>
  </div>
  }
</div>
